import { type ContentObjectList, type Pagination, createContentObjectList } from 'models';
import { useInfiniteQuery } from 'query';
import type { ApiClientResponseError, DefaultResponseErrorDataObject } from 'common/services';
import { getContentObjects } from '../../services';
import { getContentObjectsInfiniteQueryKey } from '../keys';

type P = {
  communityId?: string;
  enabled?: boolean;
  groupId?: string;
  pagination: Omit<Pagination, 'position'>;
  pinned?: boolean;
  programId?: string;
  programTopicId?: string;
};

export const useContentObjectsInfiniteQuery = ({
  communityId,
  enabled,
  groupId,
  pagination,
  pinned,
  programId,
  programTopicId,
}: P) =>
  useInfiniteQuery<ContentObjectList[], string | undefined, ApiClientResponseError<DefaultResponseErrorDataObject>>({
    async queryFn({ pageParam: cursor }) {
      const { data } = await getContentObjects({
        config: {
          params: {
            community_id: communityId,
            cursor,
            group_id: groupId,
            limit: pagination.pageSize,
            pinned,
            program_id: programId,
            program_topic_id: programTopicId,
          },
        },
      });

      return data.map((contentObject) => createContentObjectList(contentObject));
    },
    enabled,
    gcTime: 0,
    getNextPageParam: (lastPage) => (lastPage.length < pagination.pageSize ? undefined : lastPage.at(-1)?.id),
    initialPageParam: undefined,
    queryKey: getContentObjectsInfiniteQueryKey({
      filter: { communityId, groupId, pinned, programId, programTopicId },
      pagination,
    }),
  });
